<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 起保日期 -->
            <el-table-column align="left" label="起保日期" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 业务员 -->
            <el-table-column align="left" label="业务员">
            <template slot-scope="scope">
                <span >{{ scope.row.salesman }}</span>
            </template>
            </el-table-column>                             

            <!-- 代理点名称 -->
            <el-table-column align="left" label="代理点名称">
            <template slot-scope="scope">
                <span >{{ scope.row.agency_name }}</span>
            </template>
            </el-table-column>      

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" width="200px">
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span  class="text-link">{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 业务号 -->
            <el-table-column align="left" label="业务号">
            <template slot-scope="scope">
                <span >{{ scope.row.business_number }}</span>
            </template>
            </el-table-column>   

            <!-- 被保人 -->
            <el-table-column align="left" label="被保人">
            <template slot-scope="scope">
                <span >{{ scope.row.insured }}</span>
            </template>
            </el-table-column>   
                
            <!-- 实收币种 -->
            <el-table-column align="left" label="实收币种">
            <template slot-scope="scope">
                <span >{{ scope.row.paid_currency }}</span>
            </template>
            </el-table-column>

            <!-- 实收保费 -->
            <el-table-column align="left" label="实收保费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency}}</span>
            </template>
            </el-table-column>

            <!-- 费用比例(%) -->
            <el-table-column align="left" label="费用比例(%)" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate }}%</span>
            </template>
            </el-table-column>

            <!-- 手续费金额 -->
            <el-table-column align="left" label="手续费金额" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency}}</span>
            </template>
            </el-table-column>

            <!-- 实际收费金额 -->
            <el-table-column align="left" label="实际收费金额" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.actual_commission | parsecurrency}}</span>
            </template>
            </el-table-column>                

            <!-- 费用类型 -->
            <el-table-column align="left" label="费用类型" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.types_of_fee }}</span>
            </template>
            </el-table-column>          
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-dong-hai',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },        
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>